<template lang="pug">
.tabela-monitoramento-agricola
    .tabela-conteudo(v-show='!larguraTotal')
        el-table#largura-simples(
            ref='multiplaSelecao',
            :data='paginaAreasMonitoradas.itens',
            stripe,
            style='width: 100%',
            @selection-change='atualizarLinhasSelecionadas',
            @sort-change='ordenar'
        )
            el-table-column(type='expand', width='55')
                template(slot-scope='scope')
                    .box-espande-listagem
                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.idPessoa') }}:
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length > 0'
                            )
                                | {{ scope.row.territorio.representantes[0].idCliente }}
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length === 0 || scope.row.territorio.representantes[0].idCliente === null'
                            )
                                | {{ '-' }}
                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | CAR:
                            .box-espande-listagem-box-value
                                | {{ formatarCar(scope.row.territorio.cars.length ? scope.row.territorio.cars[0].codigo : null) }}
                                el-popover(placement='bottom', trigger='hover')
                                    el-tag.ml-2(
                                        v-if='Object.keys(scope.row.territorio.cars).length',
                                        size='mini',
                                        slot='reference'
                                    ) {{ scope.row.territorio.cars.length }}
                                    .lista-scroll
                                        div(
                                            v-for='(car, index) in scope.row.territorio.cars',
                                            :key='index'
                                        ) {{ car.codigo }}
                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.pessoas') }}:
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length > 0',
                                v-for='representante in scope.row.territorio.representantes'
                            )
                                | {{ representante.nomeRazaoSocial }}
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length === 0'
                            )
                                | {{ '-' }}

                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.area') }}:
                            .box-espande-listagem-box-value
                                | {{ formatAreaHa(scope.row.areaHa) }}

            el-table-column(type='selection', width='55')

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.territorio')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.nome }}

            el-table-column(:label="$t('mensagens.comuns.monitoramento.localidade')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.localidade }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.safra')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.safra ? scope.row.safra.descricao : '--' }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.alertas')", width='150')
                template(slot-scope='scope')
                    span {{ scope.row.possuiAlerta ? 'Sim' : 'Não' }}
            el-table-column(:label='$t("mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.colheita")', width='160')
                template(slot-scope='scope')
                    span {{ formatarStatus(scope.row.statusColheita) }}
            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.acoes')", width='100', align='center')
                template(slot-scope='scope')
                    el-dropdown(trigger='click')
                        span
                            i.mdi.mdi-dots-vertical.mudando-cursor
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarAreaMonitorada(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.visualizar') }}

                            el-dropdown-item(
                                icon='el-icon-circle-plus-outline',
                                @click.native='adcionarNovoCiclo(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.adicionarNovoCiclo') }}

                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarAreaMonitorada(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.editar') }}

                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='desativarAreaMonitorada(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.desativar') }}

    .tabela-conteudo.largura-total(v-show='larguraTotal')
        el-table#largura-total(
            ref='multiplaSelecaoLarguraTotal',
            :data='paginaAreasMonitoradas.itens',
            stripe,
            style='width: 100%',
            @selection-change='atualizarLinhasSelecionadas',
            @sort-change='ordenar'
        )
            el-table-column(type='selection', width='55')
            el-table-column(
                :label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.idPessoa')",
                width='120',
                align='right',
                sortable
            )
                template(slot-scope='scope')
                    span(
                        v-if='scope.row.territorio.representantes.length > 0 && scope.row.territorio.representantes[0].idCliente'
                    ) {{ scope.row.territorio.representantes[0].idCliente }}
                    span(v-else) {{ '-' }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.territorio')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.nome }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.area')", align='right', sortable)
                template(slot-scope='scope')
                    span {{ formatAreaHa(scope.row.areaHa) }}

            el-table-column(:label="$t('mensagens.comuns.monitoramento.localidade')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.localidade }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.pessoas')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.representantes.length ? scope.row.territorio.representantes[0].nomeRazaoSocial : '-' }}
                        el-popover(placement='bottom', trigger='hover')
                            el-tag.ml-2(
                                v-if='Object.keys(scope.row.territorio.representantes).length > 1',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.territorio.representantes.length }}
                            .lista-scroll
                                div(
                                    v-for='(representante, index) in scope.row.territorio.representantes',
                                    :key='index'
                                ) {{ representante.nomeRazaoSocial }}

            el-table-column(label='CAR')
                template(slot-scope='scope')
                    span {{ formatarCar(scope.row.territorio.cars.length ? scope.row.territorio.cars[0].codigo : null) }}
                        el-popover(placement='bottom', trigger='hover')
                            el-tag.ml-2(
                                v-if='Object.keys(scope.row.territorio.cars).length',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.territorio.cars.length }}

                            .lista-scroll
                                div(
                                    v-for='(car, index) in scope.row.territorio.cars',
                                    :key='index'
                                ) {{ car.codigo }}
            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.culturaEsperada')", align='center', sortable)
                template(slot-scope='scope')
                    span {{ scope.row.culturaEsperada.nome }}

            el-table-column(
                :label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.safra')",
                width='100',
                align='center',
                sortable
            )
                template(slot-scope='scope')
                    span {{ scope.row.safra ? scope.row.safra.descricao : '--' }}

            el-table-column(
                :label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.alertas')",
                width='100',
                align='center',
                sortable
            )
                template(slot-scope='scope')
                    div(v-if='scope.row.alertas.length === 0')
                        el-tag.ml-2(size='mini', slot='reference') {{ scope.row.alertas.length }}
                    div(v-else)
                        el-popover(placement='bottom', trigger='hover')
                            el-tag.ml-2(size='mini', slot='reference') {{ scope.row.alertas.length }}
                            .lista-scroll
                                div(
                                    v-for='(alerta, index) in scope.row.alertas',
                                    :key='index'
                                ) {{ alerta.tipo.descricao }}

            el-table-column(:label="$t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.acoes')", width='100', align='center')
                template(slot-scope='scope')
                    el-dropdown(trigger='click')
                        span
                            i.mdi.mdi-dots-vertical.mudando-cursor
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarAreaMonitorada(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.visualizar') }}

                            el-dropdown-item(
                                icon='el-icon-circle-plus-outline',
                                @click.native='adcionarNovoCiclo(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.adicionarNovoCiclo') }}

                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='desativarAreaMonitorada(scope.row)'
                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.desativar') }}
    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.rodape', {quantidade_selecionada: linhasSelecionadas.length, quantidade_total: paginaAreasMonitoradas.totalItens}) }}

        .tabela-rodape--pagination
            el-pagination(
                background,
                small,
                layout='prev, pager, next',
                :page-size='paginacao.tamanho',
                :current-page.sync='paginacao.pagina + 1',
                :total='paginaAreasMonitoradas.totalItens',
                @current-change='mudarPagina'
            )

    .tabela-btn
        BaseButton.button-outline(
            type='primary',
            icon='el-icon-video-pause',
            :disabled='!linhasSelecionadas.length',
            @click='desativarMonitoramentos'
        ) {{ $t('mensagens.monitoramentoAgricola.desativarMonitoramento') }}

    ModalDesativarMonitoramento(
        :mostrar='mostraModalDeasativarAreaMonitorada',
        :areasMonitoradas='areasMonitoradasDesativar',
        @atualizarTabela='atualizarTabela',
        @fechar='mostraModalDeasativarAreaMonitorada = false'

    )
    ModalEditarMonitoramentoAgricola(
        :mostrar='mostraModalEditarAreaMonitorada',
        :areaMonitorada='areaMonitoradaEditar',
        @editarMonitoramentoAgricola='editarMonitoramento',
        @fechar='mostraModalEditarAreaMonitorada = false'

    )

    ModalCadastrarMonitoramentoAgricola(
        :territoriosSelecionados='territoriosNovoCiclo',
        :show.sync='mostrarModalCadastroAgricola',
        @cadastrarMonitoramentoAgricola='cadastrarMonitoramento'
    )
</template>

<script>
import ModalDesativarMonitoramento from '@/components/monitoramento/ModalDesativarMonitoramento.vue';
import ModalCadastrarMonitoramentoAgricola from '@/components/monitoramento/ModalCadastrarMonitoramentoAgricola.vue';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import MonitoramentoService from '@/services/MonitoramentoService';
import ModalEditarMonitoramentoAgricola from '@/components/monitoramento/ModalEditarMonitoramentoAgricola.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'TabelaMonitoramentoAgricola',
    
    components: {
        ModalDesativarMonitoramento,
        ModalCadastrarMonitoramentoAgricola,
        ModalEditarMonitoramentoAgricola,
        BaseButton
    },

    emits: ['salvarFiltro'],

    props: {
        paginaAreasMonitoradas: {
            type: Object,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        larguraTotal: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            linhasSelecionadas: [],
            ordenacao: '',
            areasMonitoradasDesativar: [],
            mostraModalDeasativarAreaMonitorada: false,
            areaMonitoradaEditar: {},
            mostraModalEditarAreaMonitorada: false,
            territoriosNovoCiclo: [],
            mostrarModalCadastroAgricola: false
        };
    },

    watch: {
        paginaAreasMonitoradas() {
            this.linhasSelecionadas = [];
        }
    },

    methods: {
        atualizarLinhasSelecionadas(linhasSelecionadas) {
            this.linhasSelecionadas = linhasSelecionadas;
        },

        formatarCar(codigo) {
            if (!codigo) return '-';

            return codigo.replace(codigo.substring(8, 39), '...');
        },
        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },
        ordenar({ column, order }) {
            const nomesColunas = {
                Território: 'territorio',
                Área: 'area',
                Localidade: 'localidade',
                Representantes: 'representante',
                CAR: 'car',
                'Cultura informada': 'cultura',
                Safra: 'safra',
                'Possui alerta': 'possui_alerta'
            };
            this.ordenacao = nomesColunas[column.label];

            let sentido = '';
            if (order === 'ascending') sentido = ',asc';
            if (order === 'descending') sentido = ',desc';

            this.ordenacao += sentido;
            this.$emit('ordenar', this.ordenacao);
        },

        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },

        atualizarTabela() {
            this.mudarPagina(0);
        },

        adcionarNovoCiclo(valor) {
            this.mostrarModalCadastroAgricola = true;
            this.territoriosNovoCiclo = [{
                idTerritorio: valor.territorio.id,
                tipoMonitoramento: valor.tipoMonitoramento.codigo
            }];
        },

        cadastrarMonitoramento(areasMonitoramento) {

            MonitoramentoAgricolaService.enviarAreasMonitoramento({ areasMonitoramento })
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.territorioEnviadoParaMonitoramentoComSucesso')
                        });

                        this.territoriosNovoCiclo = [];
                        this.mostrarModalCadastroAgricola = false;

                        this.atualizarTabela();
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.ocorreuErroAoEnviarTerritorioParaMonitoramento')
                        });
                    }
                })
                .catch(e => {
                    this.$notify.error({
                        message:
                            e?.response?.data?.message ?? this.$t('mensagens.territorio.ocorreuErroAoEnviarTerritorioParaMonitoramento')
                    });
                });
        },

        editarMonitoramento(areaMonitorada) {
            MonitoramentoService.editarAreaMonitoramento(areaMonitorada)
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.monitoramentoEditadoComSucesso')
                        });

                        this.areaMonitoradaEditar = {};

                        this.atualizarTabela();
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.ocorreuErroAoEnviarTerritorioParaMonitoramento')
                        });
                    }
                })
                .catch(e => {
                    this.$notify.error({
                        message:
                            e?.response?.data?.message ?? this.$t('mensagens.territorio.erroAoEditarMonitoramento')
                    });
                });
        },

        desativarAreaMonitorada({ id }) {
            const areaMonitoradaDesativar =
                this.paginaAreasMonitoradas.itens.find(
                    areaMonitorada => areaMonitorada.id === id
                );

            this.areasMonitoradasDesativar = [areaMonitoradaDesativar];
            this.mostraModalDeasativarAreaMonitorada = true;
        },

        desativarMonitoramentos() {
            this.areasMonitoradasDesativar = this.linhasSelecionadas;
            this.mostraModalDeasativarAreaMonitorada = true;
        },
        visualizarAreaMonitorada({ id }) {
            this.$emit('salvarFiltro');
            this.$router.push({
                name: 'MonitoramentoAgricolaImovel',
                params: { id: id }
            });
        },
        editarAreaMonitorada({ id }) {
            const areaMonitoradaEditar =
                this.paginaAreasMonitoradas.itens.find(
                    areaMonitorada => areaMonitorada.id === id
                );

            this.areaMonitoradaEditar = areaMonitoradaEditar;
            this.mostraModalEditarAreaMonitorada = true;
        },
        formatarStatus(statusColheita) {
            switch (statusColheita) {
                case 'EM_COLHEITA':
                    return 'Em Colheita';
                
                case 'COLHIDO':
                    return 'Colhido';
            
                default:
                    return 'Não Realizado';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela-monitoramento-agricola {
    .tabela-conteudo {
        height: 572px;
        overflow-y: auto;
        padding: 0px 5px;
        background-color: var(--white);
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;

        &.largura-total {
            height: 100% !important;
        }

        .el-table thead {
            color: var(--primary);
            font-weight: 400;
            font-size: 13px;
        }
    }

    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .el-table__row.expanded:hover,
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell,
    .el-table__row.expanded,
    td.el-table__cell.el-table__expanded-cell {
        background-color: var(--background-rgba) !important;
    }

    .expanded td.el-table_1_column_1.undefined.el-table__expand-column.el-table__cell,
    .el-table__row.expanded,
    td.el-table__cell.el-table__expanded-cell {
        border-left: 2px solid var(--secondary) !important;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: start;
        align-items: center;
    }

    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 41% 10px 5px;
        margin-top: 6px;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px var(--block-shadow);

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }

    .box-espande-listagem {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 15px;
        margin-bottom: 15px;

        .box-espande-listagem-box {
            .box-espande-listagem-box-texto {
                font-weight: 600;
                color: var(--primary);
            }

            .box-espande-listagem-box-value {
                font-weight: 400;
                color: var(--primary);
            }
        }
    }

    .mudando-cursor {
        cursor: pointer;
    }
}

.button-green {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    i.lyra-icon::before {
        width: 13px !important;
        height: 13px !important;
        background: var(--primary) !important;
        margin-right: 6px;
    }
}

.lista-car-popover {
    margin-bottom: 1px;
}

.el-tag {
    cursor: pointer;

    .tag-car {
        margin-left: 5px;
    }
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: #606266;
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}</style>
